// removed by extract-text-webpack-plugin
module.exports = {"strong":"_31kThyiF3s"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/BankAccounts/BankAccounts.module.less
// module id = 973
// module chunks = 3